import {LitElement, html , css} from 'lit';

class SwipeCard extends LitElement {
  static styles = css`
    :host {
      display: block;
      position: absolute;
      width: 98vw;
      height: 98vh;
      overflow: hidden;
      border-radius: 4px;
    }

    .card {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      touch-action: none;
    }

    .card-label {
      position: fixed;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      padding: 10px 20px;
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      font-size: 1.2rem;
      border-radius: 5px;
      z-index: 10;
      display: none;
    }
  `;

  constructor() {
    super();
    this.startX = 0;
    this.startY = 0;
    this.currentX = 0;
    this.currentY = 0;
    this.isDragging = false;
  }

  render() {
    return html`
      <div
        class="card"
        @pointerdown="${this._onPointerDown}"
        @pointermove="${this._onPointerMove}"
        @pointerup="${this._onPointerUp}"
        @pointercancel="${this._onPointerCancel}"
      >
        <slot></slot>
        <div class="card-label"></div>
      </div>
    `;
  }

  _onPointerDown(event) {
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.isDragging = true;
    this.style.transition = 'none';
  }

  _onPointerMove(event) {
    if (!this.isDragging) return;

    this.currentX = event.clientX - this.startX;
    this.currentY = event.clientY - this.startY;

    this.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;
    this._updateLabelDuringDrag();
  }

  _updateLabelDuringDrag() {
    const threshold = 100;
    let label = '';

    if (this.currentX > threshold) {
      label = 'Approve';
    } else if (this.currentX < -threshold) {
      label = 'Screen out!';
    } else if (this.currentY > threshold) {
      label = 'Skip';
    }

    const labelElement = document.querySelector('.swipe-card-label');
    if (labelElement) {
      labelElement.textContent = label;
      labelElement.style.display = label ? 'block' : 'none';
    }
  }

  _onPointerUp() {
    if (!this.isDragging) return;

    this.isDragging = false;
    const threshold = 100;

    if (this.currentX > threshold) {
      this.dispatchEvent(new CustomEvent('swipe-card:swiped', {bubbles: true, composed: true, detail: { direction: 'right' } }));
      this.dispatchEvent(new CustomEvent('swipe-right'));
      this._removeCard();

    } else if (this.currentX < -threshold) {
      this.dispatchEvent(new CustomEvent('swipe-card:swiped', {bubbles: true, composed: true, detail: { direction: 'left' } }));
      this.dispatchEvent(new CustomEvent('swipe-left'));
      this._removeCard();

    } else if (this.currentY > threshold) {
      this.dispatchEvent(new CustomEvent('swipe-card:swiped', {bubbles: true, composed: true, detail: { direction: 'down' } }));
      this.dispatchEvent(new CustomEvent('swipe-down'));
      this._removeCard();

    } else {
      this.style.transition = 'transform 0.3s ease';
      this.style.transform = 'translate(0, 0)';
    }
  }

  _onPointerCancel() {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.style.transition = 'transform 0.3s ease';
    this.style.transform = 'translate(0, 0)';
  }

  _removeCard() {
    this.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
    this.style.opacity = '0';

    const onTransitionEnd = () => {
      this.remove();
      this.removeEventListener('transitionend', onTransitionEnd);
    };

    this.addEventListener('transitionend', onTransitionEnd);
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('pointercancel', this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('pointercancel', this);
  }

  handleEvent(event) {
    if (event.type === 'pointercancel') {
      this._onPointerCancel(event);
    }
  }
}

customElements.define('swipe-card', SwipeCard);
